export const DEFAULT_CACHE_TIME_MS = 5 * 60 * 1000
export const SHORT_CACHE_TIME_MS = 60 * 1000

export const QUERY_ONGOING_PARKING_EVENTS = 'getOngoingParkingEvents'
export const QUERY_ENDED_PARKING_EVENTS = 'getEndedParkingEvents'
export const QUERY_PARKING_EVENT_DETAILS = 'getParkingEventDetails'

export const QUERY_WHITELIST = 'getWhitelist'
export const QUERY_WHITELISTED_VEHICLE = 'getWhitelistedVehicle'

/*
// For reference:
export const QUERY_AUTH_GET_SESSION = 'getAuthSession'

export const QUERY_PLACE_GET_ALL = 'getPlaces'
export const QUERY_PLACE_GET_BY_REF = 'getPlaceByRef'
export const QUERY_PLACES_FOR_LOGIN = 'getPlacesForLogin'
export const QUERY_PLACES_BY_CUSTOMER = 'getPlacesByCustomer'

export const QUERY_REPORTS_GET_CATALOGUES = 'getCataloguesReport'
export const QUERY_REPORTS_GET_RIGHTS = 'getRightsReport'

export const QUERY_RIGHT_HOLDER_GET_BY_REF = 'getRightHolderByRef'

export const QUERY_USERS_ADMIN_GET_BY_REF = 'getAdminUsersByRef'
*/
